import React from "react";
import { DatePicker, TimePicker } from "antd";

export const MOBILE_DATE_PICKER_PROPS = {
  getPopupContainer: () => document.body,
  popupClassName: "curengo-mobile-picker",
  placement: "bottomLeft",
};

export const MOBILE_TIME_PICKER_PROPS = {
  getPopupContainer: () => document.body,
  popupClassName: "curengo-mobile-time-picker",
  placement: "bottomLeft",
  needConfirm: true,
};

export const CARE_TABLE_TIME_PICKER_BASE = {
  getPopupContainer: () => document.body,
  placement: "bottomLeft",
};

export const getCareTimePickerProps = (isMobile) => ({
  ...CARE_TABLE_TIME_PICKER_BASE,
  popupClassName: isMobile
    ? "curengo-mobile-time-picker"
    : "nurse-care-time-dropdown",
  ...(isMobile ? { needConfirm: true } : {}),
});

export const CARE_TABLE_STATUS_SELECT_PROPS = {
  getPopupContainer: () => document.body,
  placement: "bottomLeft",
  popupClassName: "nurse-care-status-dropdown",
  listHeight: 256,
};

export const withNurseCareMobilePickerProps = (node, isMobile) => {
  if (!isMobile || !React.isValidElement(node)) return node;

  if (node.type === DatePicker) {
    return React.cloneElement(node, {
      ...MOBILE_DATE_PICKER_PROPS,
      ...node.props,
    });
  }

  if (node.type === TimePicker) {
    return React.cloneElement(node, {
      ...node.props,
      ...MOBILE_TIME_PICKER_PROPS,
      needConfirm: true,
    });
  }

  if (node.props?.children == null) return node;

  const children = React.Children.map(node.props.children, (child) =>
    withNurseCareMobilePickerProps(child, isMobile)
  );

  if (children === node.props.children) return node;

  return React.cloneElement(node, node.props, children);
};

export const renderNurseCareFormItems = (formItems, isMobile) => {
  if (!isMobile || !React.isValidElement(formItems)) return formItems;

  if (formItems.type === React.Fragment) {
    return React.cloneElement(
      formItems,
      formItems.props,
      React.Children.map(formItems.props.children, (child) =>
        withNurseCareMobilePickerProps(child, isMobile)
      )
    );
  }

  return withNurseCareMobilePickerProps(formItems, isMobile);
};
